import { GET_CAR, GET_CARFACILTIES } from "resources/actionTypes";


const initialState = {
  userCar: [],
  loading: false,
  error: null,
};

const initialCarFacilities = {
  userCarFacilities: [],
  loading:false,
  error: null
}

export function userCar(state = initialState, action) {
  switch (action.type) {
    case GET_CAR.GET_CAR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CAR.GET_CAR_SUCCESS:
      return {
        ...state,
        loading: false,
        userCar: action.userCar,
      };
    case GET_CAR.GET_CAR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userCarFacilities(state = initialCarFacilities, action) {
  switch (action.type) {
    case GET_CARFACILTIES.GET_CARFACILTIES_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CARFACILTIES.GET_CARFACILTIES_SUCCESS:
      return {
        ...state,
        loading: false,
        userCarFacilities: action.userCarFacilities,
      };
    case GET_CARFACILTIES.GET_CARFACILTIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
